import { Controller } from "@hotwired/stimulus"

// Safety net for the login form: some Windows Chrome setups (typically
// password-manager extensions) swallow the implicit Enter-to-submit, so we
// listen in the capture phase and submit explicitly. requestSubmit() still
// runs native validation and the normal submit event.
export default class extends Controller {
  connect() {
    this._onKeydown = (e) => {
      if (e.key !== "Enter" || e.isComposing) return
      const target = e.target
      if (!target.matches("input")) return
      if (["button", "submit", "checkbox", "radio", "file"].includes(target.type)) return
      e.preventDefault()
      this.element.requestSubmit()
    }
    this.element.addEventListener("keydown", this._onKeydown, true)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this._onKeydown, true)
  }
}
